export enum TipoSigapEnum {
  ROL_CONTRATO,
  ACOMPANHAMENTO_CONTRATO,
  PLANILHA_OBRA_LICITACAO,
  PLANILHA_OBRA_VENCEDOR,
  RELATORIO_FOTOGRAFICO,
  PLANILHA_ACOMPANHAMENTO,
  PROJETO_CONTRATANTE,
  PROJETO_CONTRATADA
}

export const tipoSigapEnum = {
  ROL_CONTRATO: 'Rol Contratos',
  ACOMPANHAMENTO_CONTRATO: 'Acompanhamento de Contratos',
  PLANILHA_OBRA_LICITACAO: 'Planilha Obra Licitação',
  PLANILHA_OBRA_VENCEDOR: 'Planilha Obra Vencedor',
  RELATORIO_FOTOGRAFICO: 'Relatório Fotográfico',
  PLANILHA_ACOMPANHAMENTO: 'Planilha do Acompanhamento',
  PROJETO_CONTRATANTE: 'Projetos da Contratante',
  PROJETO_CONTRATADA: 'Projetos da Contratada'
};

export const tipoSigapContrato = {
  ROL_CONTRATO: tipoSigapEnum.ROL_CONTRATO
};

export const tipoSigapAditivo = {
  ACOMPANHAMENTO_CONTRATO: 'Acompanhamento de Contratos'
};

export const tipoSigapIntervencao = {
  PLANILHA_OBRA_LICITACAO: 'Planilha Obra Licitação',
  PLANILHA_OBRA_VENCEDOR: 'Planilha Obra Vencedor',
  PROJETO_CONTRATANTE: 'Projetos da Contratante',
  PROJETO_CONTRATADA: 'Projetos da Contratada'
};

export const tipoSigapAcompanhamento = {
  RELATORIO_FOTOGRAFICO: 'Relatório Fotográfico',
  PLANILHA_ACOMPANHAMENTO: 'Planilha do Acompanhamento'
};
